import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useFormikContext } from 'formik'
import { DatePicker } from '@e3dc-react/shell/Elements/InputFields'
import { WallboxTariffsFormData } from '../EMobilityWallboxTariffsEditor'
import moment from '@e3dc-react/shell/Libs/moment'

interface EMobilityWallboxDischargeTariffsDatePickerProps {
  validFrom: Date
  index: number
}

/**
 * Date picker input component for add dishcarging price.
 * @param validFrom date input value
 * @param index number of input inside FieldArray
 * @return JSX element
 */
const EMobilityWallboxDischargeTariffsDatePicker: React.FC<EMobilityWallboxDischargeTariffsDatePickerProps> = ({ validFrom, index }): JSX.Element => {
  const { setFieldValue, errors } = useFormikContext<WallboxTariffsFormData>()
  const { t } = useCustomTranslation()

  return (
    <DatePicker
      value={moment(validFrom)}
      label={t('emobility.wallbox.editTariffs.validFrom')}
      format={t('common.format.date')}
      onChange={value => setFieldValue(`dischargePrices.${index}.validFrom`, value?.toDate() ?? null)}
      clearable={false}
      helperText={(() => {
        if (!errors.dischargePrices) {
          return undefined
        }
        if (!errors.dischargePrices[index]) {
          return undefined
        }

        const err = errors.dischargePrices[index]

        if (typeof err === 'string') {
          return undefined
        }

        if (typeof err.validFrom !== 'string') {
          return undefined
        }

        return err.validFrom
      })()}
    />
  )
}

export default EMobilityWallboxDischargeTariffsDatePicker
